import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const AccordionDetails = (props): JSX.Element => {
  return <MuiAccordionDetails {...props} />;
};
